import { useAnalyticsQuery } from "@pages/analytics/hooks";
import type { TActionItem, TReadingDepthItem } from "@pages/analytics/types";
import { IconBrandSpeedtest } from "@tabler/icons-react";
import { useIntersectionObserver } from "usehooks-ts";
import { ANALYTICS_QUERY } from "../../constants";
import { useAnalyticsStoreShallow } from "../../store";
import { ActionsTable } from "../actions-table";
import { ReadingDepthFunnel } from "../reading-depth-funnel";

export const SessionPerformanceOverview = ({
  overrides,
}: {
  overrides?: Record<string, unknown>;
}) => {
  const { dateFrom, dateTo } = useAnalyticsStoreShallow((s) => ({
    dateFrom: s.date.dateFrom,
    dateTo: s.date.dateTo,
  }));
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.1,
  });
  const { data, isLoading, isError } = useAnalyticsQuery({
    query: [ANALYTICS_QUERY.SESSION_READING_DEPTH, ANALYTICS_QUERY.TOP_ACTIONS],
    enabled: isIntersecting,
    overrides: {
      dateFrom,
      dateTo,
      ...(overrides ?? {}),
    },
  });

  const readingDepthItems = data?.[
    ANALYTICS_QUERY.SESSION_READING_DEPTH
  ] as TReadingDepthItem[];
  const actions = data?.[ANALYTICS_QUERY.TOP_ACTIONS] as TActionItem[];
  return (
    <div
      ref={ref}
      className="tw-rounded-xl tw-outline tw-outline-1 tw-p-5 tw-outline-blue/5 tw-bg-white tw-shadow-2xs"
    >
      <h3 className="tw-font-sans tw-flex tw-items-center tw-gap-2 tw-text-base tw-mt-0 tw-mb-6 tw-font-semibold tw-text-blue">
        <IconBrandSpeedtest />
        Performance
      </h3>
      <div className="tw-grid tw-grid-cols-2 tw-gap-6 -lg:tw-grid-cols-1">
        <ReadingDepthFunnel
          items={readingDepthItems}
          isLoading={isLoading}
          isError={isError}
        />
        <ActionsTable
          actions={actions}
          isLoading={isLoading}
          isError={isError}
        />
      </div>
    </div>
  );
};
